import { render } from "./TieredChallengeStoreCard.vue?vue&type=template&id=5d4a6590"
import script from "./TieredChallengeStoreCard.vue?vue&type=script&lang=js"
export * from "./TieredChallengeStoreCard.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./TieredChallengeStoreCard.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild_49ef5a74%2Fpackages%2Fstore%2Fsrc%2Fcomponents%2Fchallenge%2Ftiered%2FTieredChallengeStoreCard.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__